module.exports = __webpack_public_path__ + "img/app_main_bt2.9bae0740.png";